<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
    <v-card-text>Are you sure you want to remove all payment orders ?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="warning mx-2" small @click="rmBtodAll">Yes</v-btn>
      <v-btn color="success"  small @click="dialog = false">No</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false
    }
  },
  methods: {
    open() {
       this.dialog = true;
    },
    rmBtodAll() { 
      this.$axios
        .post("ares/json/ares/task/fin/abn/rmBtodAll.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "rmBtodAll"
          },
          rmBtodAll: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             this.$router.reload('/task/fin/abn/searchBtodNew'); 
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.rmBtodAll.text,
              color: res.data.rmBtodAll.color
            });
            
            this.dialog = false;
          }
        })
    },
  }
}
</script>

